import { useState, useEffect, useRef, useCallback } from 'react';

// Bu hook, bir resim dizisi ve isteğe bağlı bir zaman aralığı alır.
export function useImageSlider(images = [], interval = 2500) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timerRef = useRef(null);

  // Slider'ı başlatan fonksiyon
  const startSlider = useCallback(() => {
    // Önceki bir zamanlayıcı varsa temizle
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    // Yeni bir zamanlayıcı kur
    timerRef.current = setInterval(() => {
      // Bir sonraki indekse geç. Dizinin sonuna geldiyse başa dön.
      setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
    }, interval);
  }, [images.length, interval]);

  // Slider'ı durduran ve başa saran fonksiyon
  const stopSlider = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    // Fare çekildiğinde ana resme (ilk resme) geri dön
    setCurrentIndex(0);
  }, []);

  // Belirli bir indekse gitmeyi sağlayan fonksiyon (thumbnail tıklamaları için)
  // Bu fonksiyon aynı zamanda slider'ı yeniden başlatır.
  const goToIndex = useCallback((index) => {
    setCurrentIndex(index);
    startSlider(); // Kullanıcı manuel seçim yaptığında zamanlayıcıyı yeniden başlat
  }, [startSlider]);

  // Component DOM'dan kaldırıldığında zamanlayıcıyı temizle (hafıza sızıntısını önler)
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  // Hook'un dışarıya sunduğu değerler ve fonksiyonlar
  return {
    currentIndex,
    currentImage: images[currentIndex] || null,
    goToIndex,
    startSlider,
    stopSlider,
  };
}